import { lt } from '@mews/framework';
import { Button, IconName } from '@optimus-web/core';
import { useDialogForm } from '@mews-commander/form';
import { AddNoteDialogContent, AddNoteDialogContentProps } from './components';

const addNoteForm = 'addNoteForm';

type AddNoteContainerProps = Pick<AddNoteDialogContentProps, 'accountsRecord' | 'reservationId'>;

export const AddNoteContainer = ({ accountsRecord, reservationId }: AddNoteContainerProps) => {
    const [renderAddNoteDialog, toggleAddNoteDialog] = useDialogForm({
        renderForm: (props) => (
            <AddNoteDialogContent accountsRecord={accountsRecord} reservationId={reservationId} {...props} />
        ),
        title: lt('GuestInHouseReportAddNoteDialogTitle'),
        id: addNoteForm,
        size: 'small',
    });

    return (
        <>
            <Button
                wide
                variant="secondary"
                size="medium"
                icon={IconName.Notes}
                onClick={toggleAddNoteDialog}
                type="submit"
            >
                {lt('AddNote')}
            </Button>
            {renderAddNoteDialog()}
        </>
    );
};
